import { Gift, Plus, Edit3, Trash2, ImagePlus } from "lucide-react";

export function DashboardRewardsTab({
  rewards, showRewardForm, setShowRewardForm, newReward, setNewReward,
  rewardLoading, rewardImage, rewardImagePreview, handleRewardImageChange,
  handleCreateReward, handleDeleteReward, openEditReward,
  editingReward, setEditingReward, editRewardImagePreview,
  handleEditRewardImageChange, handleSaveEditReward,
  setEditRewardImage, setEditRewardImagePreview,
}) {
  return (
    <div className="space-y-4">
      <button
        onClick={() => setShowRewardForm(!showRewardForm)}
        className="w-full bg-card border border-dashed border-[#FF6B35]/40 rounded-2xl p-4 flex items-center justify-center gap-2 text-[#FF6B35] hover:bg-[#FF6B35]/5 transition-colors"
        data-testid="create-reward-btn"
      >
        <Plus className="w-4 h-4" />
        <span className="text-sm font-bold">Creer une enchere</span>
      </button>

      {showRewardForm && (
        <div className="bg-card border border-border rounded-3xl p-5 space-y-4 shadow-sm" data-testid="reward-form">
          <h3 className="font-heading font-bold text-sm text-card-foreground">Nouvelle enchere</h3>
          <input
            placeholder="Titre du lot (ex: T-shirt dedicace, Appel video...)"
            value={newReward.title}
            onChange={(e) => setNewReward({ ...newReward, title: e.target.value })}
            className="w-full bg-white border border-border rounded-xl px-4 py-3 text-sm text-card-foreground placeholder:text-muted-foreground focus:border-[#FF6B35] focus:ring-1 focus:ring-[#FF6B35] outline-none"
            data-testid="reward-title-input"
          />
          <textarea
            placeholder="Description (optionnel)"
            value={newReward.description}
            onChange={(e) => setNewReward({ ...newReward, description: e.target.value })}
            className="w-full bg-white border border-border rounded-xl px-4 py-3 text-sm text-card-foreground placeholder:text-muted-foreground focus:border-[#FF6B35] focus:ring-1 focus:ring-[#FF6B35] outline-none resize-none h-16"
            data-testid="reward-desc-input"
          />
          <div>
            <p className="text-xs text-muted-foreground mb-2">Type</p>
            <div className="flex flex-wrap gap-1.5">
              {[
                { value: "dedicace", label: "Dedicace" },
                { value: "exclusive", label: "Exclusif" },
                { value: "merch", label: "Merch" },
                { value: "meet", label: "Rencontre" },
                { value: "concert", label: "Concert" },
                { value: "custom", label: "Autre" },
              ].map((t) => (
                <button
                  key={t.value}
                  onClick={() => setNewReward({ ...newReward, type: t.value })}
                  className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${
                    newReward.type === t.value
                      ? "bg-[#FF6B35] text-white"
                      : "bg-white border border-border text-muted-foreground"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>
          </div>
          <div className="grid grid-cols-2 gap-3">
            <div>
              <p className="text-xs text-muted-foreground mb-1">Mise de depart</p>
              <input
                type="number" min="1" value={newReward.starting_price}
                onChange={(e) => setNewReward({ ...newReward, starting_price: parseInt(e.target.value) || 1 })}
                className="w-full bg-white border border-border rounded-xl px-4 py-2 text-sm text-card-foreground focus:border-[#FF6B35] focus:ring-1 focus:ring-[#FF6B35] outline-none"
                data-testid="reward-price-input"
              />
            </div>
            <div>
              <p className="text-xs text-muted-foreground mb-1">Duree (heures)</p>
              <input
                type="number" min="1" value={newReward.duration_hours}
                onChange={(e) => setNewReward({ ...newReward, duration_hours: parseInt(e.target.value) || 24 })}
                className="w-full bg-white border border-border rounded-xl px-4 py-2 text-sm text-card-foreground focus:border-[#FF6B35] focus:ring-1 focus:ring-[#FF6B35] outline-none"
                data-testid="reward-duration-input"
              />
            </div>
          </div>
          <div>
            <p className="text-xs text-muted-foreground mb-2">Photo du lot (optionnel)</p>
            <label className="flex items-center justify-center gap-2 w-full border-2 border-dashed border-border rounded-xl p-3 cursor-pointer hover:border-[#FF6B35]/40 transition-colors bg-white">
              {rewardImagePreview ? (
                <img src={rewardImagePreview} alt="preview" className="w-full h-28 object-cover rounded-lg" />
              ) : (
                <>
                  <ImagePlus className="w-5 h-5 text-muted-foreground" />
                  <span className="text-sm text-muted-foreground">Ajouter une photo</span>
                </>
              )}
              <input type="file" accept="image/*" className="hidden" onChange={handleRewardImageChange} data-testid="reward-image-input" />
            </label>
          </div>
          <div className="flex gap-2">
            <button
              onClick={handleCreateReward}
              disabled={rewardLoading || !newReward.title.trim()}
              className="bg-[#FF6B35] text-white font-bold px-6 py-2.5 rounded-full text-sm hover:scale-105 active:scale-95 transition-transform disabled:opacity-50"
              data-testid="reward-submit-btn"
            >
              {rewardLoading ? "..." : "Creer l'enchere"}
            </button>
            <button
              onClick={() => setShowRewardForm(false)}
              className="bg-muted text-muted-foreground px-4 py-2.5 rounded-full text-sm border border-border"
            >
              Annuler
            </button>
          </div>
        </div>
      )}

      {rewards.length === 0 ? (
        <div className="text-center py-12">
          <Gift className="w-10 h-10 text-muted-foreground mx-auto mb-3" />
          <p className="text-sm text-muted-foreground">Aucune enchere creee</p>
          <p className="text-xs text-muted-foreground mt-1">Mets des lots exclusifs aux encheres</p>
        </div>
      ) : (
        rewards.map((r) => (
          <div
            key={r.id}
            className={`bg-card border rounded-2xl p-4 shadow-sm transition-colors ${
              r.status === "active" ? "border-border" : "border-border opacity-60"
            }`}
            data-testid={`artist-reward-${r.id}`}
          >
            <div className="flex items-center gap-3">
              {r.image_url ? (
                <img src={r.image_url} alt={r.title} className="w-10 h-10 rounded-xl object-cover shrink-0" />
              ) : (
                <div className="w-10 h-10 rounded-xl bg-[#FF6B35]/15 flex items-center justify-center shrink-0">
                  <Gift className="w-5 h-5 text-[#FF6B35]" />
                </div>
              )}
              <div className="flex-1 min-w-0">
                <p className="font-heading font-bold text-sm text-card-foreground truncate">{r.title}</p>
                <div className="flex items-center gap-2 mt-0.5 flex-wrap">
                  <span className="font-mono-credits font-bold text-xs text-[#FF6B35]">
                    {r.current_bid || r.starting_price} cr
                  </span>
                  <span className="text-[10px] text-muted-foreground">{r.total_bids || 0} mises</span>
                  <span className={`text-[10px] px-1.5 py-0.5 rounded-full ${
                    r.status === "active" ? "bg-emerald-50 text-emerald-500" :
                    r.status === "claimed" ? "bg-yellow-50 text-yellow-600" :
                    "bg-muted text-muted-foreground"
                  }`}>
                    {r.status === "active" ? "En cours" : r.status === "claimed" ? "Remporte" : "Terminee"}
                  </span>
                  {r.winner_pseudo && (
                    <span className="text-[10px] text-card-foreground/80">Gagnant: {r.winner_pseudo}</span>
                  )}
                </div>
              </div>
              {r.status === "active" && (
                <div className="flex items-center gap-1 shrink-0">
                  <button
                    onClick={() => openEditReward(r)}
                    className="p-1.5 rounded-lg text-muted-foreground hover:text-[#FF6B35] hover:bg-[#FF6B35]/10 transition-colors"
                    data-testid={`edit-reward-${r.id}`}
                    title="Modifier"
                  >
                    <Edit3 className="w-4 h-4" />
                  </button>
                  {(r.total_bids || 0) === 0 && (
                    <button
                      onClick={() => handleDeleteReward(r.id)}
                      className="p-1.5 rounded-lg text-muted-foreground hover:text-red-500 hover:bg-red-50 transition-colors"
                      data-testid={`delete-reward-${r.id}`}
                      title="Supprimer"
                    >
                      <Trash2 className="w-4 h-4" />
                    </button>
                  )}
                </div>
              )}
            </div>
          </div>
        ))
      )}

      {editingReward && (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4" onClick={() => setEditingReward(null)}>
          <div className="bg-card rounded-3xl p-6 w-full max-w-md space-y-4 shadow-xl max-h-[85vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid="edit-reward-modal">
            <h3 className="font-heading font-bold text-lg text-card-foreground">Modifier l'enchere</h3>
            {(editingReward.total_bids || 0) > 0 && (
              <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 flex items-start gap-2" data-testid="edit-reward-warning">
                <span className="text-amber-500 text-base mt-0.5">!</span>
                <p className="text-xs text-amber-700">Des fans ont deja mise sur cette enchere. Seuls le titre et la description peuvent etre modifies.</p>
              </div>
            )}
            <input
              value={editingReward.title}
              onChange={(e) => setEditingReward({ ...editingReward, title: e.target.value })}
              className="w-full bg-white border border-border rounded-xl px-4 py-2.5 text-sm text-card-foreground focus:border-[#FF6B35] focus:ring-1 focus:ring-[#FF6B35] outline-none"
              placeholder="Titre"
              data-testid="edit-reward-title"
            />
            <textarea
              value={editingReward.description || ""}
              onChange={(e) => setEditingReward({ ...editingReward, description: e.target.value })}
              className="w-full bg-white border border-border rounded-xl px-4 py-2.5 text-sm text-card-foreground focus:border-[#FF6B35] focus:ring-1 focus:ring-[#FF6B35] outline-none resize-none"
              rows={2}
              placeholder="Description"
              data-testid="edit-reward-desc"
            />
            <div className={`${(editingReward.total_bids || 0) > 0 ? "opacity-40 pointer-events-none" : ""}`}>
              <p className="text-xs text-muted-foreground mb-2">Type</p>
              <div className="flex flex-wrap gap-1.5">
                {[
                  { value: "dedicace", label: "Dedicace" },
                  { value: "exclusive", label: "Exclusif" },
                  { value: "merch", label: "Merch" },
                  { value: "meet", label: "Rencontre" },
                  { value: "concert", label: "Concert" },
                  { value: "custom", label: "Autre" },
                ].map((t) => (
                  <button
                    key={t.value}
                    onClick={() => setEditingReward({ ...editingReward, type: t.value })}
                    className={`px-3 py-1 rounded-full text-xs font-bold transition-colors ${
                      editingReward.type === t.value
                        ? "bg-[#FF6B35] text-white"
                        : "bg-white border border-border text-muted-foreground"
                    }`}
                  >
                    {t.label}
                  </button>
                ))}
              </div>
            </div>
            <div className={`${(editingReward.total_bids || 0) > 0 ? "opacity-40 pointer-events-none" : ""}`}>
              <p className="text-xs text-muted-foreground mb-2">Mise de depart (credits)</p>
              <input
                type="number" min="1"
                value={editingReward.starting_price}
                onChange={(e) => setEditingReward({ ...editingReward, starting_price: parseInt(e.target.value) || 1 })}
                className="w-full bg-white border border-border rounded-xl px-4 py-2.5 text-sm text-card-foreground focus:border-[#FF6B35] focus:ring-1 focus:ring-[#FF6B35] outline-none"
                data-testid="edit-reward-price"
              />
            </div>
            <div className={`${(editingReward.total_bids || 0) > 0 ? "opacity-40 pointer-events-none" : ""}`}>
              <p className="text-xs text-muted-foreground mb-2">Photo du lot</p>
              <label className="flex items-center justify-center gap-2 w-full border-2 border-dashed border-border rounded-xl p-3 cursor-pointer hover:border-[#FF6B35]/40 transition-colors bg-white">
                {editRewardImagePreview ? (
                  <img src={editRewardImagePreview} alt="preview" className="w-full h-28 object-cover rounded-lg" />
                ) : (
                  <>
                    <ImagePlus className="w-5 h-5 text-muted-foreground" />
                    <span className="text-sm text-muted-foreground">Ajouter une photo</span>
                  </>
                )}
                <input type="file" accept="image/*" className="hidden" onChange={handleEditRewardImageChange} data-testid="edit-reward-image-input" />
              </label>
            </div>
            <div className="flex gap-2 pt-2">
              <button
                onClick={handleSaveEditReward}
                disabled={rewardLoading || !editingReward.title.trim()}
                className="bg-[#FF6B35] text-white font-bold px-6 py-2.5 rounded-full text-sm hover:scale-105 active:scale-95 transition-transform disabled:opacity-50"
                data-testid="edit-reward-save-btn"
              >
                {rewardLoading ? "..." : "Enregistrer"}
              </button>
              <button
                onClick={() => { setEditingReward(null); setEditRewardImage(null); setEditRewardImagePreview(null); }}
                className="bg-muted text-muted-foreground px-4 py-2.5 rounded-full text-sm border border-border"
              >
                Annuler
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
